function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "fb-w",
  transform: "translate(-327.155 -120.375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Exclus\\xE3o_1",
  "data-name": "Exclus\\xE3o 1",
  d: "M15349.315,5484.63a7.646,7.646,0,1,1,7.65-7.646A7.653,7.653,0,0,1,15349.315,5484.63Zm-1.338-7.635v4.656h1.932V5477h1.295s.123-.753.181-1.576h-1.469v-1.072a.461.461,0,0,1,.421-.377h1.048v-1.63h-1.426a2.071,2.071,0,0,0-1.521.512,1.727,1.727,0,0,0-.461,1.277v1.294h-.937V5477Z",
  transform: "translate(-15014.518 -5348.962)"
}));

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.293,
    height: 15.293,
    viewBox: "0 0 15.293 15.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.001981bf.svg";
export { ForwardRef as ReactComponent };